import { Component, OnInit, Inject } from '@angular/core';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelect } from '@angular/material';
import { ICoupon } from 'src/app/interfaces/coupon';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import * as moment from "jalali-moment";
import { MarketerService } from 'src/app/services/http/business/marketer/marketer.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { environment } from 'src/environments/environment';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-coupon-entry',
  templateUrl: './coupon-entry.component.html',
  styleUrls: ['./coupon-entry.component.css']
})
export class CouponEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = []
  disabled = false;
  errObject: any;
  form: FormGroup;
  companyList: ICompany[];
  couponCategory = [];
  marketerList = [];
  errors = new Array();
  completePercent = 0;

  constructor(
    private companyService: CompanyService,
    private couponService: CouponService,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private cidService: CIDService,
    private marketerService: MarketerService,
    private dialogRef: MatDialogRef<CouponEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICoupon) { }

  ngOnInit() {
    this.getCompanyList();
    this.createCouponForm();
    this.getCouponCategory();
  }

  createCouponForm() {
    this.form = this.fb.group({
      //CodeLength: [10],
      CompanyEncryptId: [null, Validators.compose([Validators.required])],
      ExpirationDate: [null, Validators.compose([Validators.required])],
      StartDate: [null, Validators.compose([Validators.required])],
      CouponCategoryId: [null, Validators.compose([Validators.required])],
      MarketerId: [null, Validators.compose([Validators.required])],
      //IsGroupCoupon: [true],
      CouponCount: [null, Validators.compose([Validators.required])]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getCouponCategory() {
    this.couponService.couponCategory().subscribe(res => {
      this.couponCategory = res;
    });
  }

  getMarketers(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.marketerService.list(e.value, null, 0, 0).subscribe(res => {
      this.marketerList = res.DataList;
    });
  }

  submit(form: ICoupon) {
    this.errors = new Array();
    this.disabled = true;
    let data: ICoupon = {
      CouponCategoryId: form.CouponCategoryId,
      CouponCount: form.CouponCount,
      ExpirationDate: moment.from(form.ExpirationDate, "en").utc(true).format(environment.dateFormat),
      //.toJSON(),
      MarketerId: form.MarketerId,
      StartDate: moment.from(form.StartDate, "en").utc(true).format(environment.dateFormat),
      //.toJSON(),
    };
    this.couponService.addCoupon(data).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        this.translate.get("success.couponsAdd"),
        "ok",
        5000,
        SoundEnum.beep
      );
    }, err => {
      this.disabled = false;
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })
    //let calls = [];
    //for (var i = 1; i <= form.Count; i++) {
    //  var model = {
    //    CodeLength: form.CodeLength,
    //    ExpirationDate: this.form.value.ExpirationDate = moment
    //      .from(form.ExpirationDate, "en")
    //      .utc(true)
    //      .toJSON(),
    //    CompanyEncryptId: form.CompanyEncryptId,
    //    Discount: form.Discount,
    //    IsGroupCoupon: form.IsGroupCoupon,
    //    Count: form.Count
    //  };
    //  calls.push(this.couponService.addAdmin(model));
    //}

    //forkJoin(...calls).subscribe(res => {
    //},
    //  err => {
    //    this.errObject = this.errorService.getError(err);
    //    this.param = this.errorService.objectError(this.errObject);
    //    this.errors = this.errorService.returnError(err);
    //  },
    //  () => {
    //    this.dialogRef.close();
    //    this.snackBar.OpenSnackBar(
    //      this.translate.get("success.couponsAdd"),
    //      "ok",
    //      5000,
    //      SoundEnum.beep
    //    );
    //  }
    //);
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
